import { createRoot } from 'react-dom/client'
// import { auth } from './firebase';
// Axios
import axios from 'axios'
import { Chart, registerables } from 'chart.js'
import { QueryClient, QueryClientProvider } from 'react-query'
// import { ReactQueryDevtools } from 'react-query/devtools'
// Apps
import { Fourthreal18nProvider } from './_4threal/i18n/FourthReal18n'
import './_4threal/assets/fonticon/fonticon.css'
import './_4threal/assets/keenicons/duotone/style.css'
import './_4threal/assets/keenicons/outline/style.css'
import './_4threal/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_4threal/assets/css/style.rtl.css'
 **/
import './_4threal/assets/sass/style.scss'
import './_4threal/assets/sass/plugins.scss'
import './_4threal/assets/sass/style.react.scss'

// Fonts
import './_4threal/helpers/fonts/Kanit/Kanit-Bold.ttf'

import { AppRoutes } from './app/routing/AppRoutes'
import { AuthProvider, setupAxios } from './app/modules/auth'
import { Provider } from 'react-redux'
import store from './redux/store'
// import { onAuthStateChanged } from 'firebase/auth';
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic _4threal mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject _4threal interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)
Chart.register(...registerables)

const queryClient = new QueryClient()
const container = document.getElementById('root')

if (container) {
  createRoot(container).render(
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <Fourthreal18nProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </Fourthreal18nProvider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </Provider>
  )
}

